import IPerson from "../../interfaces/IPerson";

export const requestPersons = "REQUEST_FETCH_PERSONS";
const successFetchPersons = "SUCCESS_FETCH_PERSONS";
const failureFetchPersons = "FAILURE_FETCH_PERSONS";

export const requestPersonsByProcessorRole = "REQUEST_FETCH_PERSONS_BY_PROCESSOR_ROLE";
const successFetchPersonsByProcessorRole = "SUCCESS_FETCH_PERSONS_BY_PROCESSOR_ROLE";
const failureFetchPersonsByProcessorRole = "FAILURE_FETCH_PERSONS_BY_PROCESSOR_ROLE";

const appendToPersonList = "APPEND_TO_PERSON_LIST";


export interface IRequestFetchPersons {
    type: typeof requestPersons;
    payload: { personIds: number[] };
}

interface ISuccessFetchPersons {
    type: typeof successFetchPersons;
    payload: { persons: IPerson[] };
}

interface IFailureFetchPersons {
    type: typeof failureFetchPersons;
    payload: { error: Error; personIds: number[] };
}


export interface IRequestFetchPersonsByProcessorRole {
    type: typeof requestPersonsByProcessorRole;
}

interface ISuccessFetchPersonsByProcessorRole {
    type: typeof successFetchPersonsByProcessorRole;
    payload: { persons: IPerson[] };
}

interface IFailureFetchPersonsByProcessorRole {
    type: typeof failureFetchPersonsByProcessorRole;
    payload: { error: Error };
}



interface IAppendToPersonList {
    type: typeof appendToPersonList;
    payload: { persons: IPerson[] };
}


export type IPersonAction
    = IRequestFetchPersons
    | ISuccessFetchPersons
    | IFailureFetchPersons

    | IRequestFetchPersonsByProcessorRole
    | ISuccessFetchPersonsByProcessorRole
    | IFailureFetchPersonsByProcessorRole

    | IAppendToPersonList
    ;

export const createRequestFetchPersons = (personIds: number[]): IRequestFetchPersons => ({
    type: requestPersons,
    payload: { personIds }
});

export const createSuccessFetchPersons = (persons: IPerson[]): ISuccessFetchPersons => ({
    type: successFetchPersons,
    payload: { persons },
});

export const createFailureFetchPersons = (error: Error, personIds: number[]): IFailureFetchPersons => ({
    type: failureFetchPersons,
    payload: { error, personIds },
});

export const createAppendToPersonList = (persons: IPerson[]): IAppendToPersonList => ({
    type: appendToPersonList,
    payload: { persons },
});



export const createRequestFetchPersonsByProcessorRoleAction = (): IRequestFetchPersonsByProcessorRole => ({
    type: requestPersonsByProcessorRole,
});

export const createSuccessFetchPersonsByProcessorRoleAction = (persons: IPerson[]): ISuccessFetchPersonsByProcessorRole => ({
    type: successFetchPersonsByProcessorRole,
    payload: { persons },
});

export const createFailureFetchPersonsByProcessorRoleAction = (error: Error): IFailureFetchPersonsByProcessorRole => ({
    type: failureFetchPersonsByProcessorRole,
    payload: { error },
});